import { render } from "./AddressInformation.vue?vue&type=template&id=5375f0c7&ts=true"
import script from "./AddressInformation.vue?vue&type=script&lang=ts"
export * from "./AddressInformation.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__